module.exports = __webpack_public_path__ + "static/img/activity1.e08bea1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/activity/activity1.png
// module id = OTes
// module chunks = 1